import { NavController, NavParams, App, ModalController, ViewController, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { Component, OnInit, Input } from '@angular/core';

import { AuthProvider } from '../../../../providers/auth/auth';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';


@Component({
  selector: 'page-rh-amazement',
  templateUrl: 'rh-amazement.html',
})
export class RhAmazementPage implements OnInit {

  amazement:any = null;
  answers: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    public app: App,
    public authProvider: AuthProvider,
    public employeeRhProvider: EmployeeRhProvider,
    public viewCtrl: ViewController,
    public toastCtrl: ToastController
  ) {
  }

  ngOnInit() {
        this.loadDatas();
  }

  loadDatas() {
    this.employeeRhProvider.getAmazementQuestions().subscribe((res) => {
        if(res.success){
            this.amazement = res.data;

            this.amazement.forEach(currQuestion => {
                this.answers[currQuestion.id] = {
                    question_id : currQuestion.id,
                    option: null,
                    string: null,
                  };
            });
        }
    })
  }

  checkHandle(currQuestionId, currOption) {
    this.answers[currQuestionId].option = currOption; 
  }

  submitSurvey(){
    let payload = [];
    let answers = this.answers;
    let hasAnsweredAll = true;
    const toastController = this.toastCtrl;

       Object.keys(answers).forEach(function (key){
         if(answers[key].option == null && answers[key].string == null){  // Didn't answer to all question
            hasAnsweredAll = false;
         }
         payload.push({
             question_id: answers[key].question_id,
             answer_boolean: answers[key].option,
             answer_text : answers[key].string
         })
       });

       if(!hasAnsweredAll){

        let toast = toastController.create({ message: "Merci de répondre à toutes les questions", duration: 6000, position: 'top'});
        toast.present();
        return;

       }else {

        this.employeeRhProvider.amazementSubmitAnswer(payload).subscribe((res) => {
            if(res.success){
                let toast = this.toastCtrl.create({ message: "Vos réponses ont été envoyées", duration: 6000, position: 'bottom'});
                toast.present();
                this.dismiss();
            }
        });
        
    }
  }


   
// Modal ctrl
dismiss() {
    this.viewCtrl.dismiss();
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/rh-amazement/rh-amazement.ts